import type { ReactNode } from 'react';
import { IpponBadge, IpponHSpace, IpponText } from '@ippon-ui/react';
import type { Rule } from '@/rule/domain/Rule.ts';
import { useOrganizationText } from '@/rule/primary/UseOrganizationText.ts';
import { useRuleIdText } from '@/rule/primary/UseRuleIdText.ts';
import { useSeverityText } from '@/rule/primary/UseSeverityText.ts';

export const RuleHeadingComponent = ({ rule, children }: { rule: Rule; children?: ReactNode }) => {
  const idText = useRuleIdText(rule.id);
  const severityText = useSeverityText(rule.severity);
  const organizationText = useOrganizationText(rule.organizationId);

  return (
    <IpponHSpace gap={8} align="middle">
      {children}
      <IpponText
        variant="body"
        size="small"
        weight="bold"
        color="brand-primary"
        dataSelector="rule.id"
      >
        {idText}
      </IpponText>
      <IpponText variant="body" size="small" dataSelector="rule.title">
        {rule.title.value}
      </IpponText>
      <IpponBadge dataSelector="rule.severity">{severityText}</IpponBadge>
      <IpponBadge dataSelector="rule.organization" color="neutral">
        {organizationText}
      </IpponBadge>
    </IpponHSpace>
  );
};
